import template from './requestForm.html';
import controller from './requestForm.controller';
import './requestForm.scss';

let requestFormComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
    userInceptionId: '<',
    onSuccess: '&',
    onError: '&',
    onDismiss: '&',
    startDate: '<',
    addEvent: '&',
    mode: '<',
    periodToEdit: '<',
    originalPeriod: '<',
    type: '<',
    sicknessLeaveAnswer: '<',
    lockOn: '<',
    isMobileApp: '<',
    resetForm: '&',
    backup: '<',
    emitData:'&'
  },
  template,
  controller
};

export default requestFormComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestForm.component.js